module.exports = __webpack_public_path__ + "img/bg_about1.ad647f52.jpg";